import PropTypes from 'prop-types';

const IconServiceEnding = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
    height="24"
    width="24"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path
      fill={props.color ? props.color : '#000000'}
      d="m22 5.7-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4 6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
    />
    <path fill={props.color ? props.color : '#000000'} d="M8.7 9.7h6.6v6.6H8.7z" />
  </svg>
);

IconServiceEnding.propTypes = {
  color: PropTypes.string
};

export default IconServiceEnding;
